import { render, staticRenderFns } from "./main-button.component.vue?vue&type=template&id=53664db2&scoped=true&"
import script from "./main-button.component.vue?vue&type=script&lang=ts&"
export * from "./main-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./main-button.component.vue?vue&type=style&index=0&id=53664db2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53664db2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
